import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { BarChart3, ShoppingCart, FlaskConical, Beaker, Settings, Info, HelpCircle, LogOut } from 'lucide-react';

function Navbar({ isAuthenticated, onLogout, username }) {
    const userRole = localStorage.getItem('role');
    const location = useLocation();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const getInitial = (name) => {
        return name ? name.charAt(0).toUpperCase() : '';
    };

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <nav className="navbar">
            <div className="nav-links">
                {userRole === 'lab' ? (
                    <>
                        <Link to="/hospital-portal" className={`nav-link ${isActive('/hospital-portal')}`} title="Test Entries">
                            <span className="icon"><FlaskConical size={20} strokeWidth={1.5} /></span>
                            <span className="label">Test Entries</span>
                        </Link>
                        <Link to="/help" className={`nav-link ${isActive('/help')}`} title="Help">
                            <span className="icon"><HelpCircle size={20} strokeWidth={1.5} /></span>
                            <span className="label">Help</span>
                        </Link>
                    </>
                ) : userRole === 'admin' ? (
                    <>
                        <Link to="/dashboardPage" className={`nav-link ${isActive('/dashboardPage')}`} title="Dashboard">
                            <span className="icon"><BarChart3 size={20} strokeWidth={1.5} /></span>
                            <span className="label">Dashboard</span>
                        </Link>
                        <Link to="/sales-details" className={`nav-link ${isActive('/sales-details')}`} title="Sales">
                            <span className="icon"><ShoppingCart size={20} strokeWidth={1.5} /></span>
                            <span className="label">Sales</span>
                        </Link>
                        <Link to="/hospital-portal" className={`nav-link ${isActive('/hospital-portal')}`} title="Lab Section">
                            <span className="icon"><Beaker size={20} strokeWidth={1.5} /></span>
                            <span className="label">Lab Section</span>
                        </Link>
                        <Link to="/management" className={`nav-link ${isActive('/management')}`} title="Management">
                            <span className="icon"><Settings size={20} strokeWidth={1.5} /></span>
                            <span className="label">Management</span>
                        </Link>
                        <Link to="/about" className={`nav-link about-link ${isActive('/about')}`} title="About">
                            <span className="icon"><Info size={20} strokeWidth={1.5} /></span>
                            <span className="label">About</span>
                        </Link>
                    </>
                ) 
                : userRole === 'Super_Admin' ? (
                    <>
                        <Link to="/dashboardPage" className={`nav-link ${isActive('/dashboardPage')}`} title="Dashboard">
                            <span className="icon"><BarChart3 size={20} strokeWidth={1.5} /></span>
                            <span className="label">Dashboard</span>
                        </Link>
                        <Link to="/sales-details" className={`nav-link ${isActive('/sales-details')}`} title="Sales">
                            <span className="icon"><ShoppingCart size={20} strokeWidth={1.5} /></span>
                            <span className="label">Sales</span>
                        </Link>
                        <Link to="/hospital-portal" className={`nav-link ${isActive('/hospital-portal')}`} title="Lab Section">
                            <span className="icon"><Beaker size={20} strokeWidth={1.5} /></span>
                            <span className="label">Lab Section</span>
                        </Link>
                        <Link to="/management" className={`nav-link ${isActive('/management')}`} title="Management">
                            <span className="icon"><Settings size={20} strokeWidth={1.5} /></span>
                            <span className="label">Management</span>
                        </Link>
                        <Link to="/about" className={`nav-link about-link ${isActive('/about')}`} title="About">
                            <span className="icon"><Info size={20} strokeWidth={1.5} /></span>
                            <span className="label">About</span>
                        </Link>
                    </>
                )
                : userRole === 'sales_rep' ? (
                    <>
                    <Link to="/dashboardPage" className={`nav-link ${isActive('/dashboardPage')}`} title="Dashboard">
                            <span className="icon"><BarChart3 size={20} strokeWidth={1.5} /></span>
                            <span className="label">Dashboard</span>
                        </Link>
                        <Link to="/sales-details" className={`nav-link ${isActive('/sales-details')}`} title="Sales">
                            <span className="icon"><ShoppingCart size={20} strokeWidth={1.5} /></span>
                            <span className="label">Sales</span>
                        </Link>
                        <Link to="/about" className={`nav-link about-link ${isActive('/about')}`} title="About">
                            <span className="icon"><Info size={20} strokeWidth={1.5} /></span>
                            <span className="label">About</span>
                        </Link>
                    </>
                ) : userRole === 'sales_viewer' ? (
                    <>
                        <Link to="/sales-details" className={`nav-link ${isActive('/sales-details')}`} title="Sales Details">
                            <span className="icon"><ShoppingCart size={20} strokeWidth={1.5} /></span>
                            <span className="label">Sales Details</span>
                        </Link>
                    </>
                ) : userRole === 'regional_sales_head' ? (
                    <>
                        <Link to="/dashboardPage" className={`nav-link ${isActive('/dashboardPage')}`} title="Dashboard">
                            <span className="icon"><BarChart3 size={20} strokeWidth={1.5} /></span>
                            <span className="label">Dashboard</span>
                        </Link>
                        <Link to="/sales-details" className={`nav-link ${isActive('/sales-details')}`} title="Sales">
                            <span className="icon"><ShoppingCart size={20} strokeWidth={1.5} /></span>
                            <span className="label">Sales</span>
                        </Link>
                        <Link to="/about" className={`nav-link about-link ${isActive('/about')}`} title="About">
                            <span className="icon"><Info size={20} strokeWidth={1.5} /></span>
                            <span className="label">About</span>
                        </Link>
                    </>
                ) : null}
            </div>

            {isAuthenticated && (
                <div className="user-profile" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <div className="user-icon">{getInitial(username)}</div>
                    <span className="user-name">{username}</span>
                    {dropdownOpen && (
                        <div className="dropdown-menu">
                            <div className="dropdown-header">
                                Signed in as <strong>{username}</strong>
                            </div>
                            <button onClick={onLogout} className="dropdown-item">
                                <LogOut size={16} className="logout-icon" />
                                <span>Logout</span>
                            </button>
                        </div>
                    )}
                </div>
            )}
        </nav>
    );
}

export default Navbar;
